export default __webpack_public_path__ + "static/media/banner-background.a53a0479.svg";